<script>
	import UIIcon from "./UIIcon.svelte";

	import base from "../stores/base";
	import router from "../stores/router";

	// フッターの場合
	export let bottom = false;

	// 記事ページのタイトル
	export let title = "";

	// ぱんくずリスト
	let items = [];
	$: {
		items = [{ label: "TOP", url: "/" }];
		let category = $router.params.category;
		if (category) {
			if ($base.categories[category]) {
				let label = $base.categories[category][$base.lang];
				if ($router.params.id) {
					items.push({ label, url: "/" + category });
					items.push({ label: title });
				} else {
					items.push({ label });
				}
			}
		} else {
			let dir = $router.path.slice(1);
			let label = "";
			$base.menu.forEach((item) => {
				if (item.url.slice(1) === dir) {
					label = item.label[$base.lang];
				}
			});
			items.push({ label });
		}
	}
</script>

<section class="UIBreadcrumb" class:_bottom={bottom}>
	<div class="UIBreadcrumb-slider">
		<nav class="UIBreadcrumb-nav">
			{#each items as { label, url }}
				{#if url}
					<a
						href={url}
						on:click|preventDefault={() => router.push(url)}
						>{label.replace(/(<([^>]+)>)/gi, "")}</a
					>
					<UIIcon type="right" size={14} />
				{:else}
					<span>{label.replace(/(<([^>]+)>)/gi, "")}</span>
				{/if}
			{/each}
		</nav>
	</div>
</section>

<style global>
	.UIBreadcrumb {
		color: #524e4e;
		border-top: 1px solid #ccc;
		overflow-y: hidden;
		font-size: 0.85em;
		padding: 0 1em;
		border-bottom: 1px solid #ccc;
	}
	/* :global(.pc) .UIBreadcrumb {
		padding: 0 2em;
	} */

	.UIBreadcrumb._bottom {
		border-top: 1px solid #ccc;
		border-bottom: none;
	}

	.UIBreadcrumb-slider {
		padding: 1em;
	}
	:global(.pc) .UIBreadcrumb-slider {
		padding: 1em 2em;
	}

	.UIBreadcrumb-nav {
		white-space: nowrap;
	}

	.UIBreadcrumb-nav > * {
		vertical-align: middle;
		display: inline-block;
		line-height: 1.4;
	}
	.UIBreadcrumb-nav > a {
		border-bottom: 1px solid #bb5858;
		color: #bb5858;
	}
	.UIBreadcrumb-nav > a:focus {
		border-bottom: 1px dashed #bb5858;
	}
	.UIBreadcrumb-nav > svg {
		margin: 0 0.5em;
	}
	.UIBreadcrumb-nav > span {
		padding-right: 1em;
	}
</style>
